var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _line2, _line3, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoCardsInBatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 95,
    viewBox: "0 0 52 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 33,
    height: 83,
    fill: "#F5F6FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 45,
    height: 83,
    fill: "#F5F6F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 52,
    height: 83,
    fill: "#EFF1F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6155,
    y: 29.9231,
    width: 13.8462,
    height: 15.6923,
    rx: 5.53846,
    stroke: "#313C52",
    strokeWidth: 1.84615
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8462,
    y: 48.3846,
    width: 20.3077,
    height: 15.6923,
    rx: 5.53846,
    stroke: "#313C52",
    strokeWidth: 1.84615
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6924,
    y: 34.5385,
    width: 18.4615,
    height: 1.84615,
    fill: "#313C52"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.3757,
    y1: 48.655,
    x2: 26.6527,
    y2: 54.9319,
    stroke: "#313C52",
    strokeWidth: 1.84615
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.923077,
    x2: 8.87691,
    y2: -0.923077,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 32.277 49.3077)",
    stroke: "#313C52",
    strokeWidth: 1.84615
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25.8769,
    y1: 53.4923,
    x2: 25.8769,
    y2: 65,
    stroke: "#313C52",
    strokeWidth: 1.84615
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 77,
    width: 24,
    height: 2,
    fill: "#313C52"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 77,
    width: 2,
    height: 2,
    fill: "#313C52"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 77,
    width: 2,
    height: 2,
    fill: "#313C52"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCardsInBatch);
export default __webpack_public_path__ + "static/media/noCardsInBatch.8c1a8889715819b741e50bde2334b79f.svg";
export { ForwardRef as ReactComponent };